'use client';
import { jsx } from 'react/jsx-runtime';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { useFormFieldProps } from '../form/form.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const TextArea = renderWithRef('TextArea', null, (t, i)=>{
    let a = useId(t.id), p = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, t), {
        id: a
    })), s = useFormFieldProps(p.id), l = _object_spread({}, p, s), b = new Set([
        'swan-textarea'
    ]), { children: f, skin: u = 'standard', resize: O = 'both', fullWidth: j = false } = l, y = _object_without_properties(l, [
        "children",
        "skin",
        "resize",
        "fullWidth"
    ]);
    return ('error' === u || y['aria-invalid']) && b.add("swan-textarea-skin-error"), j && b.add("swan-textarea-full-width"), 'vertical' === O && b.add("swan-textarea-resize-vertical"), jsx(RenderComp, {
        root: "textarea",
        classNames: b,
        forwardedRef: i,
        props: y,
        children: f
    });
});

export { TextArea };
